module.exports = __webpack_public_path__ + "static/media/land0.2ff864c3.png";